import useDataset from "datasets/hooks/useDataset";
import yn from "yn";
import useUserPermission from "~/hooks/useUserPermission";

const { VITE_DATASET_PERMISSIONS_ENABLED } = import.meta.env;

/**
 * Hook that returns `true` if the current user has the required dataset permission.
 * Confirms permissions with catalog when feature flag is enabled.
 *
 * @param permission a single dataset action (e.g. "create:catalog-report")
 * @returns
 */
const usePermissions = (permission: string): boolean => {
  const { data: dataset } = useDataset();
  const hasPermission = useUserPermission(permission);

  /**
   * When dataset permissions is enabled, confirm auth0 permissions with Catalog API
   */
  if (yn(VITE_DATASET_PERMISSIONS_ENABLED)) {
    return !!dataset?.actions_permitted.includes(permission) && hasPermission;
  }

  return hasPermission;
};

export default usePermissions;
